module.exports = __webpack_public_path__ + "static/media/code-slash-outline.1a474c94.svg";